import Swal from "sweetalert2";

export const showSwal = (icon, title, text) => {
    Swal.fire({
        icon,
        title,
        text,
        confirmButtonText: "Close",
        allowOutsideClick: false,
    });
};

// utils/alerts.js
export const showAlertAndNavigate = (icon, title, text, token) => {
    Swal.fire({
        icon,
        title,
        text,
        confirmButtonText: "Continue",
        allowOutsideClick: false
    }).then((result) => {
        if (result.isConfirmed) {
            window.location.href = `/?token=${token}`;
        }
    });
};

